// extracted by mini-css-extract-plugin
export default {"container":"VN0Yc","inner":"dJQsT","title":"Pz9uK","buttonContainer":"PrHO7","button":"MySOd","wrapper":"OhdKB","loader":"jzOHY"};